export class RegistrationServiceLocation {
  public id: string;
  public serviceLocationId: string;
  public jsonDeterminants: string;
  public sortOrder: number;
  public registrationId: string;
  public name: string;
}
